// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-input__colorpicker .clr-field button {\n    width: 32px;\n    height: 32px;\n    left: 6px;\n    right: auto;\n    border-radius: 4px;\n\tz-index: 22;\n}\n.form-input__colorpicker .clr-field  {\n\twidth: 100%;\n}\n.form-input__colorpicker .clr-field input {\n\tpadding-left: 48px;\n\tposition: relative;\n    min-height: 48px;\n    border: solid 1px var(--color-slate-two);\n    border-radius: 4px;\n\twidth: 100%;\n    box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
